import { render, staticRenderFns } from "./lesson-upload.vue?vue&type=template&id=6b960a46&scoped=true"
import script from "./lesson-upload.vue?vue&type=script&lang=js"
export * from "./lesson-upload.vue?vue&type=script&lang=js"
import style0 from "./lesson-upload.vue?vue&type=style&index=0&id=6b960a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b960a46",
  null
  
)

export default component.exports